import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      loading: false,
      currentData: {},
      switchVisible: false,
      switchValue: false
    };
  },
  created: function created() {
    this.getCurrentData();
  },
  methods: {
    getCurrentData: function getCurrentData() {
      var _this = this;
      this.loading = true;
      this.$http({
        url: '/web/payroll_setting/managelist',
        method: 'GET'
      }).then(function (res) {
        var item = res.data[0];
        _this.currentData = item;
        _this.switchValue = item.status === '1';
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleConfirm: function handleConfirm() {
      this.switchVisible = false;
      this.switchValue = !this.switchValue;
      this.currentData.status = this.switchValue ? '1' : '0';
      this.$http({
        url: '/web/payroll_setting/updateSettingStatus',
        data: {
          setting_id: this.currentData.id,
          status: this.currentData.status
        }
      });
    }
  }
};